import React, { useEffect, useState } from 'react';
import { IMicroPageInfo } from './interface';
import { FormLabel } from '../formLabel';
import { lang } from '@umu/ukit-lang';
import { UmuInput } from '@umu/umu-design';
import { InputChangeData, TextareaChangeData } from '@umu/umu-design/es/components/UmuInput';
import { getChartLimitLenByLang, getInputCountType } from '../../../../@utils/inputStatistics';

interface IBasicInfoProps extends React.HTMLAttributes<HTMLDivElement> {
    isValid?: boolean;
    info: IMicroPageInfo;
    onInfoChange: (data: IMicroPageInfo) => void;
}
interface IBasicInfoErrorParams {
    value: string;
    currentLength: number;
    maxLength: number;
    isValid?: boolean;
    emptyMsg?: string;
}
const MAX_TITLE_COUNT = 50; // 最大标题长度
const MAX_DESC_COUNT = 100; // 最大描述长度
/**
 * @desc 获取错误信息
 */
const getErrorMsg = (info: IBasicInfoErrorParams) => {
    const { value, currentLength, maxLength, isValid = false, emptyMsg = '' } = info;
    const newVal = value.trim();
    if (isValid && !newVal.length) {
        return emptyMsg;
    }
    return currentLength >= maxLength ? lang('最多可输入${0}字').replace('${0}', String(maxLength)) : '';
};
/**
 * @desc 微页面基础配置信息
 */
const BasicInfo = (props: IBasicInfoProps) => {
    const { className = '', info, isValid = false, onInfoChange, ...rest } = props;
    const [errorInfo, setErrorInfo] = useState({
        title: '',
        desc: '',
    });
    const onTitleChange = (data: InputChangeData) => {
        const { value, length } = data;
        onInfoChange({
            title: value,
        } as IMicroPageInfo);
        setErrorInfo({
            ...errorInfo,
            title: getErrorMsg({
                value,
                currentLength: length,
                maxLength: getChartLimitLenByLang(MAX_TITLE_COUNT),
                isValid,
                emptyMsg: lang('请输入微页面名称'),
            }),
        });
    };
    useEffect(() => {
        isValid &&
            setErrorInfo({
                ...errorInfo,
                title: getErrorMsg({
                    value: info.title || '',
                    currentLength: info.title?.length || 0,
                    maxLength: getChartLimitLenByLang(MAX_TITLE_COUNT),
                    isValid,
                    emptyMsg: lang('请输入微页面名称'),
                }),
            });
    }, [isValid]);
    const onDescChange = (data: TextareaChangeData) => {
        const { value, length } = data;
        onInfoChange({
            desc: value,
        } as IMicroPageInfo);
        setErrorInfo({
            ...errorInfo,
            desc: getErrorMsg({
                value,
                currentLength: length,
                maxLength: getChartLimitLenByLang(MAX_DESC_COUNT),
            }),
        });
    };
    const countType = getInputCountType();
    return (
        <div className={`micro-page-basic-setting-info ${className}`} {...rest}>
            <FormLabel label={lang('微页面名称')} className="form-label-rows" isRequire>
                <UmuInput
                    value={info.title || ''}
                    error={errorInfo.title}
                    onChange={onTitleChange}
                    maxLength={getChartLimitLenByLang(MAX_TITLE_COUNT)}
                    countType={countType}
                    expandConfig={{ placeholder: lang('输入页面名称，会展示在页面标题栏') }}
                />
            </FormLabel>
            <FormLabel label={lang('微页面备注')} className="form-label-rows">
                <UmuInput.Textarea
                    value={info.desc || ''}
                    error={errorInfo.desc}
                    maxLength={getChartLimitLenByLang(MAX_DESC_COUNT)}
                    countType={countType}
                    onChange={onDescChange}
                    expandConfig={{
                        autoSize: {
                            minRows: 5,
                            maxRows: 8,
                        },
                        placeholder: lang(
                            '可填写备注，记录页面的使用目的等，便于后续编辑维护，最多可输入${0}字字',
                        ).replace('${0}', getChartLimitLenByLang(MAX_DESC_COUNT)),
                    }}
                />
            </FormLabel>
        </div>
    );
};
export { BasicInfo };
